module.exports = __webpack_public_path__ + "img/seta.c8c786bf.png";